import { APIGet, APIPost, APIPut, APIDelete, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
import { TModifierGroup } from "redux/reducers/models/facility";
import { IVariantModifier } from "pages/secure/facility/settings/modifierGroup/ModifierGroupEdit";

const apiVersion = "2024-04";
const adminType = "facility-admin";
const baseUrl = "/" + apiVersion + "/" + adminType + "/product/modifier-group";

export type TGetModifierGroup = {
  id?: string | number;
  product_id?: number;
  /** Returns attached variants */
  extended?: boolean;
};

export type TPostModifierGroup = {
  title: string;
  multi_select?: boolean; // Defaults to false
  required?: boolean; // Defaults to false
};

export type TPutModifierGroup = {
  id: string | number;
  title?: string;
  multi_select?: boolean;
  required?: boolean;
};

export type TPostModifierGroupVariant = {
  modifier_group_id?: number;
  variants?: IVariantModifier[];
};

export async function GetModifierGroup(params: TGetModifierGroup, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<TModifierGroup[]>(
    APIUrl(AdminType.FacilityAdmin, "/product/modifier-group"),
    params,
    useGlobalLoader,
    token,
  );
}

export async function PostModifierGroup(params: TPostModifierGroup, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/product/modifier-group"), params, useGlobalLoader);
}

export async function PutModifierGroup(params: TPutModifierGroup, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/product/modifier-group"), params, useGlobalLoader);
}

export async function DeleteModifierGroup(params: { id: string | number }, useGlobalLoader: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/product/modifier-group"), params, useGlobalLoader);
}

/** Add array of existing variants to a modifier group */
export async function PostModifierGroupVariants(params: TPostModifierGroupVariant, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/product/modifier-group/variant"), params, useGlobalLoader);
}
